import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { InstitutionService } from '../../services/institution.service';
import { IInstitution } from '../../interfaces/institution.interface';
import { useToast } from '../../context/ToastContext';

const InstitutionDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const toast = useToast();
    const [institution, setInstitution] = useState<IInstitution | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            loadData();
        }
    }, [id]);

    const loadData = async () => {
        try {
            setLoading(true);
            const inst = await InstitutionService.getInstitutionById(id!);
            setInstitution(inst);
        } catch (error) {
            toast.showApiError(error, 'Failed to load institution details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Box sx={{ p: 3 }}><Typography>Loading...</Typography></Box>;
    }

    if (!institution) {
        return <Box sx={{ p: 3 }}><Typography>Institution not found</Typography></Box>;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Button startIcon={<ArrowBack />} onClick={() => navigate('/institutions')}>
                    Back
                </Button>
                <Typography variant="h5">{institution.name}</Typography>
            </Box>

            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>Institution Info</Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Name</Typography>
                        <Typography>{institution.name}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Code</Typography>
                        <Typography>{institution.code}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Description</Typography>
                        <Typography>{institution.description || '-'}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Admin Email</Typography>
                        <Typography>{institution.email || '-'}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Fiscal Year Start Month</Typography>
                        <Typography>{institution.fiscalYearStartMonth}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary">Status</Typography>
                        <Typography>
                            {!institution.approved ? 'Not Approved' : institution.isActive === false ? 'Deactivated' : 'Active'}
                        </Typography>
                    </Box>
                </Box>
            </Paper>

        </Box>
    );
};

export default InstitutionDetail;
